// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   导航栏容器
======================================== */
.navbar-container {
  display: flex;
  justify-content: stretch;
  margin-bottom: 24px;
  padding-top: 14px;
}

/* ========================================
   导航栏主体
======================================== */
.navbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: none;
  padding: 12px 18px;
  position: relative;
  overflow: visible;
}

.navbar .container-fluid {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  margin: 0;
}

.navbar-mobile-toggle {
  display: none;
}

.navbar::before,
.navbar::after {
  display: none;
}

/* ========================================
   品牌区域
======================================== */
.brand-section {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 18px;
  padding-right: 20px;
  border-right: 1px solid #e5e7eb;
}

.main-brand {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.daat-logo {
  width: 154px;
  max-height: 46px;
  height: auto;
  object-fit: cover;
  object-position: left center;
  border-radius: 8px;
  filter: none;
  transition: none;
}

.daat-logo:hover {
  filter: none;
}

.brand-tagline {
  font-size: 10px;
  color: #718096;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-top: -8px;
}

/* 集成工具 Logo */
.integrated-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tools-label {
  font-size: 11px;
  color: #a0aec0;
  font-weight: 500;
  margin-right: 4px;
}

.tool-logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f8fafc;
  opacity: 1;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease;
  text-decoration: none;
}

.tool-logo-link:hover {
  border-color: #bfdbfe;
  background: #eff6ff;
  transform: none;
}

.tool-logo-link img {
  width: 24px;
  max-height: 20px;
  height: auto;
  object-fit: contain;
  border-radius: 0;
}

/* ========================================
   导航链接区域
======================================== */
.right-navbar-container {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  width: 100%;
  align-items: center;
  gap: 14px;
  min-width: 0;
  position: relative;
  z-index: 10;
}

.navbar .nav {
  width: 100%;
}

.nav-items-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-width: 0;
}

.navbar-user-slot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.nav-item-container {
  position: relative;
  z-index: auto;
}

.nav-item-container:has(.nav-dropdown),
.nav-item-container:has(#nav-dropdown) {
  z-index: 1000;
}

/* 导航项分隔线 */
.nav-item-container + .nav-item-container::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 60%;
  background: linear-gradient(180deg, 
    transparent 0%, 
    rgba(0, 0, 0, 0.06) 50%, 
    transparent 100%
  );
}

/* 增强的导航链接 */
.nav-link-enhanced {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  color: #4a5568;
  padding: 10px 16px !important;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  background: transparent;
  text-decoration: none;
}

.nav-icon {
  font-size: 16px;
  opacity: 0.8;
  transition: transform 0.3s ease;
}

.nav-label {
  position: relative;
  z-index: 1;
}

.nav-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 80%;
  height: 3px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px 3px 0 0;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 渐变边框效果 */
.nav-link-enhanced::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 10px;
  padding: 1px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.nav-link-enhanced:hover {
  color: #667eea;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
  transform: translateY(-2px);
  text-decoration: none;
}

.nav-link-enhanced:hover::before {
  opacity: 1;
}

.nav-link-enhanced:hover .nav-icon {
  transform: scale(1.15);
}

.nav-link-enhanced.active,
.nav-link.active {
  color: #667eea;
  font-weight: 600;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.nav-link-enhanced.active .nav-indicator {
  transform: translateX(-50%) scaleX(1);
}

/* 普通导航链接样式 */
.nav-link {
  font-weight: 500;
  color: #4a5568;
  padding: 8px 16px !important;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 14px;
}

.nav-link:hover {
  font-weight: 500;
  color: #667eea;
  background: rgba(102, 126, 234, 0.05);
  transform: translateY(-1px);
}

.nav-item + .nav-item {
  margin-left: 0;
}

/* ========================================
   用户区域
======================================== */
.user-section {
  display: flex;
  align-items: center;
  gap: 0;
  margin-left: 24px;
  padding-left: 24px;
  border-left: 2px solid #e2e8f0;
}

/* 快捷操作按钮 */
.quick-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
  transform: translateY(-2px);
}

.action-btn .icon {
  font-size: 18px;
}

.action-btn .badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: linear-gradient(135deg, #f56565 0%, #c53030 100%);
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

/* 用户下拉菜单 */
.user-dropdown .dropdown-toggle,
.user-dropdown .user-toggle {
  display: flex !important;
  align-items: center;
  gap: 12px;
  padding: 8px 16px !important;
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  background: white !important;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #2d3748 !important;
}

.user-dropdown .dropdown-toggle:hover,
.user-dropdown .user-toggle:hover {
  background: #f7fafc !important;
  border-color: #667eea !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.user-dropdown .dropdown-toggle::after {
  display: none !important;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.user-email {
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
}

.user-org {
  font-size: 11px;
  color: #718096;
}

.dropdown-arrow {
  font-size: 10px;
  color: #a0aec0;
  transition: transform 0.3s ease;
  margin-left: auto;
}

.user-dropdown.show .dropdown-arrow {
  transform: rotate(180deg);
}

/* 用户菜单 */
.user-menu {
  min-width: 280px !important;
  padding: 8px !important;
  border-radius: 12px !important;
  box-shadow: 
    0 0 0 1px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 12px 32px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.98) !important;
  margin-top: 8px !important;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border-radius: 8px;
  margin-bottom: 8px;
}

.user-avatar-large {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  flex-shrink: 0;
}

.user-details {
  flex: 1 1;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 2px;
}

.user-role {
  font-size: 12px;
  color: #718096;
  text-transform: capitalize;
}

.menu-item {
  display: flex !important;
  align-items: center;
  gap: 12px;
  padding: 10px 12px !important;
  border-radius: 6px !important;
  font-size: 14px;
  color: #4a5568 !important;
  transition: all 0.2s ease;
  text-decoration: none !important;
}

.menu-item:hover {
  background: rgba(102, 126, 234, 0.08) !important;
  color: #667eea !important;
}

.menu-item .item-icon {
  font-size: 18px;
  opacity: 0.8;
}

@media (max-width: 1500px) {
  .nav-label {
    display: inline;
  }

  .nav-link-enhanced {
    justify-content: flex-start;
    gap: 8px;
    padding: 9px 12px !important;
  }
}

.menu-item.logout {
  color: #e53e3e !important;
}

.menu-item.logout:hover {
  background: rgba(229, 62, 62, 0.08) !important;
  color: #c53030 !important;
}

/* ========================================
   下拉菜单优化
======================================== */
.nav-dropdown,
#nav-dropdown,
.dropdown-toggle {
  font-weight: 500;
  color: #4a5568 !important;
  padding: 10px 16px !important;
  border-radius: 10px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-size: 14px !important;
  background: transparent !important;
  border: none !important;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-dropdown::after,
#nav-dropdown::after {
  margin-left: 4px;
}

.dropdown-toggle:hover,
.nav-dropdown:hover {
  color: #667eea !important;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%) !important;
  transform: translateY(-2px);
}

.dropdown-menu {
  border-radius: 12px !important;
  box-shadow: 
    0 0 0 1px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 12px 32px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.98) !important;
  margin-top: 8px !important;
  padding: 8px !important;
  z-index: 1050 !important;
  min-width: 180px !important;
}

.dropdown-item {
  font-size: 14px;
  padding: 8px 16px !important;
  transition: all 0.2s ease;
  border-radius: 6px !important;
  color: #4a5568 !important;
}

.dropdown-item:hover {
  background: rgba(102, 126, 234, 0.1) !important;
  color: #667eea !important;
}

.dropdown-item.active {
  background: rgba(102, 126, 234, 0.15) !important;
  color: #667eea !important;
  font-weight: 600;
}

.dropdown-divider {
  margin: 8px 0;
  border-top: 1px solid #e2e8f0;
}

/* ========================================
   响应式设计
======================================== */
@media (max-width: 1600px) {
  .navbar {
    padding: 12px 16px;
  }

  .nav-link-enhanced {
    padding: 8px 10px !important;
    font-size: 13px;
  }
}

@media (max-width: 1400px) {
  .navbar {
    padding: 12px 20px;
  }
  
  .nav-link-enhanced {
    padding: 8px 10px !important;
    font-size: 12px;
  }
  
  .brand-section {
    gap: 16px;
    padding-right: 16px;
  }
  
  .daat-logo {
    width: 140px;
  }
  
  .brand-tagline {
    font-size: 9px;
  }
  
  .tool-logo-link img {
    width: 24px;
  }
  
  .user-section {
    margin-left: 16px;
    padding-left: 16px;
  }
}

@media (max-width: 1500px) {
  .navbar-container {
    margin-bottom: 16px;
    padding-top: 10px;
  }

  .navbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 40px;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 12px;
  }

  .brand-section {
    min-width: 0;
    gap: 10px;
    padding-right: 0;
    border-right: 0;
  }

  .daat-logo {
    width: 104px;
    max-height: 36px;
  }

  .integrated-tools {
    gap: 5px;
  }

  .tool-logo-link {
    width: 28px;
    height: 28px;
    padding: 3px;
    border-radius: 7px;
  }

  .tool-logo-link img {
    width: 19px;
    max-height: 17px;
  }

  .navbar-mobile-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid #dbe3ef;
    border-radius: 8px;
    background: #fff;
    color: #334155;
  }

  .navbar-mobile-toggle:hover,
  .navbar-mobile-toggle:focus-visible {
    border-color: #93c5fd;
    background: #eff6ff;
    color: #1d4ed8;
    outline: none;
  }

  .navbar .container-fluid {
    display: none !important;
    grid-column: 1 / -1;
    padding-top: 10px;
    border-top: 1px solid #eef2f7;
  }

  .navbar.mobile-menu-open .container-fluid {
    display: block !important;
  }

  .navbar .nav,
  .right-navbar-container,
  .nav-items-center {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .right-navbar-container,
  .nav-items-center {
    gap: 4px;
  }

  .nav-item-container,
  .nav-link-enhanced,
  #nav-dropdown {
    width: 100%;
  }

  .nav-label {
    display: inline;
  }

  .nav-link-enhanced,
  #nav-dropdown {
    justify-content: flex-start;
    min-height: 42px;
    padding: 9px 12px !important;
    font-size: 13px !important;
  }

  .navbar-user-slot {
    justify-content: stretch;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #eef2f7;
  }

  .user-section,
  .user-dropdown,
  .user-dropdown .user-toggle {
    width: 100%;
  }

  .user-section {
    margin-left: 0;
    padding-left: 0;
    border-left: 0;
  }

  .user-menu {
    width: 100%;
    min-width: 0 !important;
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  .brand-tagline {
    display: none;
  }
  
  .tools-label {
    display: none;
  }
  
  .nav-label {
    display: none;
  }
  
  .nav-link-enhanced {
    padding: 8px !important;
    gap: 0;
  }
  
  .nav-icon {
    font-size: 18px;
  }
}

/* ========================================
   其他样式
======================================== */
.NavLink-with-divider {
  border-right: none;
  padding: 0;
  position: relative;
}

.NavLink-with-divider::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 55%;
  border-left: 2px solid rgb(200, 200, 200);
}

.left-navbar-container {
  display: flex;
  flex-direction: row;
  margin-left: 1rem;
}

.custom-style {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
}

.nav-item-container + .nav-item-container::before,
.nav-link-enhanced::before {
  display: none;
}

.nav-link-enhanced,
.nav-link {
  justify-content: center;
  text-align: center;
  gap: 8px;
  border-radius: 10px;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 11px !important;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.nav-link-enhanced:hover,
.nav-link:hover {
  background: #f1f5f9;
  color: #1d4ed8;
  transform: none;
}

.nav-link-enhanced.active,
.nav-link.active {
  background: #eff6ff !important;
  color: #1d4ed8 !important;
  box-shadow: none;
}

.nav-icon {
  width: 15px;
  height: 15px;
  color: currentColor;
  opacity: 0.9;
}

.nav-link-enhanced:hover .nav-icon {
  transform: none;
}

.nav-indicator {
  display: none;
}

.user-section {
  margin-left: 14px;
  padding-left: 14px;
  border-left: 1px solid #e5e7eb;
}

.user-dropdown .dropdown-toggle,
.user-dropdown .user-toggle {
  gap: 10px;
  padding: 6px 10px !important;
  border-radius: 12px !important;
  box-shadow: none !important;
}

.user-dropdown .dropdown-toggle:hover,
.user-dropdown .user-toggle:hover {
  background: #f8fafc !important;
  border-color: #bfdbfe !important;
  box-shadow: none;
}

.user-avatar,
.user-avatar-large {
  background: #2563eb;
  box-shadow: none;
}

.user-email {
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.user-org {
  color: #64748b;
}

.dropdown-toggle:hover,
.nav-dropdown:hover {
  background: #f1f5f9 !important;
  color: #1d4ed8 !important;
  transform: none;
}

.dropdown-menu,
.user-menu {
  border: 1px solid #e5e7eb !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.12) !important;
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
}

.menu-header {
  background: #f8fafc;
}

.menu-item .item-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
}

.navbar .nav-link-enhanced,
.navbar #nav-dropdown {
  white-space: nowrap;
}

@media (min-width: 769px) and (max-width: 1500px) {
  .navbar.mobile-menu-open .nav-items-center {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .brand-section {
    gap: 12px;
    padding-right: 12px;
  }

  .daat-logo {
    width: 128px;
  }

  .integrated-tools {
    gap: 5px;
  }

  .tool-logo-link {
    width: 30px;
    height: 30px;
  }

  .right-navbar-container {
    gap: 8px;
  }

  .nav-items-center {
    gap: 2px;
  }

  .navbar .nav-link-enhanced,
  .navbar #nav-dropdown {
    gap: 5px;
    padding: 7px !important;
    font-size: 12px !important;
  }

  .user-section {
    margin-left: 4px;
    padding-left: 4px;
  }

  .user-dropdown .dropdown-toggle,
  .user-dropdown .user-toggle {
    gap: 8px;
    padding: 6px 8px !important;
  }
}

@media (max-width: 1500px) {
  .navbar.mobile-menu-open .nav-label {
    display: inline;
  }

  .navbar .nav-link-enhanced {
    justify-content: flex-start;
    gap: 8px;
    min-height: 42px;
    padding: 9px 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/NavBar.css"],"names":[],"mappings":"AAAA;;0CAE0C;AAC1C;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;0CAE0C;AAC1C;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;0CAE0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gEAAgE;EAChE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;0CAE0C;AAC1C;EACE,aAAa;EACb,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX;;;;GAIC;AACH;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,iDAAiD;EACjD,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qCAAqC;EACrC,UAAU;EACV,WAAW;EACX,4DAA4D;EAC5D,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,sFAAsF;EACtF;;6BAE2B;EAE3B,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gGAAgG;EAChG,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gGAAgG;EAChG,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;0CAE0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,WAAW;AACX;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B;;;8CAG4C;EAC5C,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;EAC3B,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gGAAgG;EAChG,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,QAAQ;IACR,4BAA4B;EAC9B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;0CAE0C;AAC1C;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,4DAA4D;EAC5D,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,2GAA2G;EAC3G,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B;;;8CAG4C;EAC5C,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;EAC3B,gDAAgD;EAChD,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;0CAE0C;AAC1C;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;IAGE,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,QAAQ;EACV;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,2BAA2B;IAC3B,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,MAAM;EACR;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;0CAE0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,SAAS;EACT,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,yDAAyD;EACzD,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,QAAQ;IACR,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,QAAQ;IACR,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;IAChB,4BAA4B;EAC9B;AACF","sourcesContent":["/* ========================================\n   导航栏容器\n======================================== */\n.navbar-container {\n  display: flex;\n  justify-content: stretch;\n  margin-bottom: 24px;\n  padding-top: 14px;\n}\n\n/* ========================================\n   导航栏主体\n======================================== */\n.navbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: none;\n  padding: 12px 18px;\n  position: relative;\n  overflow: visible;\n}\n\n.navbar .container-fluid {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.navbar-mobile-toggle {\n  display: none;\n}\n\n.navbar::before,\n.navbar::after {\n  display: none;\n}\n\n/* ========================================\n   品牌区域\n======================================== */\n.brand-section {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  gap: 18px;\n  padding-right: 20px;\n  border-right: 1px solid #e5e7eb;\n}\n\n.main-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.daat-logo {\n  width: 154px;\n  max-height: 46px;\n  height: auto;\n  object-fit: cover;\n  object-position: left center;\n  border-radius: 8px;\n  filter: none;\n  transition: none;\n}\n\n.daat-logo:hover {\n  filter: none;\n}\n\n.brand-tagline {\n  font-size: 10px;\n  color: #718096;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-top: -8px;\n}\n\n/* 集成工具 Logo */\n.integrated-tools {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tools-label {\n  font-size: 11px;\n  color: #a0aec0;\n  font-weight: 500;\n  margin-right: 4px;\n}\n\n.tool-logo-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #f8fafc;\n  opacity: 1;\n  cursor: pointer;\n  transition: background-color 0.18s ease, border-color 0.18s ease;\n  text-decoration: none;\n}\n\n.tool-logo-link:hover {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n  transform: none;\n}\n\n.tool-logo-link img {\n  width: 24px;\n  max-height: 20px;\n  height: auto;\n  object-fit: contain;\n  border-radius: 0;\n}\n\n/* ========================================\n   导航链接区域\n======================================== */\n.right-navbar-container {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  width: 100%;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  position: relative;\n  z-index: 10;\n}\n\n.navbar .nav {\n  width: 100%;\n}\n\n.nav-items-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  min-width: 0;\n}\n\n.navbar-user-slot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.nav-item-container {\n  position: relative;\n  z-index: auto;\n}\n\n.nav-item-container:has(.nav-dropdown),\n.nav-item-container:has(#nav-dropdown) {\n  z-index: 1000;\n}\n\n/* 导航项分隔线 */\n.nav-item-container + .nav-item-container::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 60%;\n  background: linear-gradient(180deg, \n    transparent 0%, \n    rgba(0, 0, 0, 0.06) 50%, \n    transparent 100%\n  );\n}\n\n/* 增强的导航链接 */\n.nav-link-enhanced {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  color: #4a5568;\n  padding: 10px 16px !important;\n  border-radius: 10px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 14px;\n  background: transparent;\n  text-decoration: none;\n}\n\n.nav-icon {\n  font-size: 16px;\n  opacity: 0.8;\n  transition: transform 0.3s ease;\n}\n\n.nav-label {\n  position: relative;\n  z-index: 1;\n}\n\n.nav-indicator {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%) scaleX(0);\n  width: 80%;\n  height: 3px;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  border-radius: 3px 3px 0 0;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 渐变边框效果 */\n.nav-link-enhanced::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 10px;\n  padding: 1px;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));\n  -webkit-mask: \n    linear-gradient(#fff 0 0) content-box, \n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.nav-link-enhanced:hover {\n  color: #667eea;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);\n  transform: translateY(-2px);\n  text-decoration: none;\n}\n\n.nav-link-enhanced:hover::before {\n  opacity: 1;\n}\n\n.nav-link-enhanced:hover .nav-icon {\n  transform: scale(1.15);\n}\n\n.nav-link-enhanced.active,\n.nav-link.active {\n  color: #667eea;\n  font-weight: 600;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\n}\n\n.nav-link-enhanced.active .nav-indicator {\n  transform: translateX(-50%) scaleX(1);\n}\n\n/* 普通导航链接样式 */\n.nav-link {\n  font-weight: 500;\n  color: #4a5568;\n  padding: 8px 16px !important;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  font-size: 14px;\n}\n\n.nav-link:hover {\n  font-weight: 500;\n  color: #667eea;\n  background: rgba(102, 126, 234, 0.05);\n  transform: translateY(-1px);\n}\n\n.nav-item + .nav-item {\n  margin-left: 0;\n}\n\n/* ========================================\n   用户区域\n======================================== */\n.user-section {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin-left: 24px;\n  padding-left: 24px;\n  border-left: 2px solid #e2e8f0;\n}\n\n/* 快捷操作按钮 */\n.quick-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.action-btn:hover {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n  transform: translateY(-2px);\n}\n\n.action-btn .icon {\n  font-size: 18px;\n}\n\n.action-btn .badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: linear-gradient(135deg, #f56565 0%, #c53030 100%);\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n/* 用户下拉菜单 */\n.user-dropdown .dropdown-toggle,\n.user-dropdown .user-toggle {\n  display: flex !important;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px !important;\n  border-radius: 12px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: white !important;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #2d3748 !important;\n}\n\n.user-dropdown .dropdown-toggle:hover,\n.user-dropdown .user-toggle:hover {\n  background: #f7fafc !important;\n  border-color: #667eea !important;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n}\n\n.user-dropdown .dropdown-toggle::after {\n  display: none !important;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.user-email {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.user-org {\n  font-size: 11px;\n  color: #718096;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  color: #a0aec0;\n  transition: transform 0.3s ease;\n  margin-left: auto;\n}\n\n.user-dropdown.show .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n/* 用户菜单 */\n.user-menu {\n  min-width: 280px !important;\n  padding: 8px !important;\n  border-radius: 12px !important;\n  box-shadow: \n    0 0 0 1px rgba(0, 0, 0, 0.04),\n    0 4px 12px rgba(0, 0, 0, 0.08),\n    0 12px 32px rgba(0, 0, 0, 0.12) !important;\n  border: none !important;\n  backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.98) !important;\n  margin-top: 8px !important;\n}\n\n.menu-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.user-avatar-large {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 18px;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n  flex-shrink: 0;\n}\n\n.user-details {\n  flex: 1;\n}\n\n.user-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 2px;\n}\n\n.user-role {\n  font-size: 12px;\n  color: #718096;\n  text-transform: capitalize;\n}\n\n.menu-item {\n  display: flex !important;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px !important;\n  border-radius: 6px !important;\n  font-size: 14px;\n  color: #4a5568 !important;\n  transition: all 0.2s ease;\n  text-decoration: none !important;\n}\n\n.menu-item:hover {\n  background: rgba(102, 126, 234, 0.08) !important;\n  color: #667eea !important;\n}\n\n.menu-item .item-icon {\n  font-size: 18px;\n  opacity: 0.8;\n}\n\n@media (max-width: 1500px) {\n  .nav-label {\n    display: inline;\n  }\n\n  .nav-link-enhanced {\n    justify-content: flex-start;\n    gap: 8px;\n    padding: 9px 12px !important;\n  }\n}\n\n.menu-item.logout {\n  color: #e53e3e !important;\n}\n\n.menu-item.logout:hover {\n  background: rgba(229, 62, 62, 0.08) !important;\n  color: #c53030 !important;\n}\n\n/* ========================================\n   下拉菜单优化\n======================================== */\n.nav-dropdown,\n#nav-dropdown,\n.dropdown-toggle {\n  font-weight: 500;\n  color: #4a5568 !important;\n  padding: 10px 16px !important;\n  border-radius: 10px !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  font-size: 14px !important;\n  background: transparent !important;\n  border: none !important;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.nav-dropdown::after,\n#nav-dropdown::after {\n  margin-left: 4px;\n}\n\n.dropdown-toggle:hover,\n.nav-dropdown:hover {\n  color: #667eea !important;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%) !important;\n  transform: translateY(-2px);\n}\n\n.dropdown-menu {\n  border-radius: 12px !important;\n  box-shadow: \n    0 0 0 1px rgba(0, 0, 0, 0.04),\n    0 4px 12px rgba(0, 0, 0, 0.08),\n    0 12px 32px rgba(0, 0, 0, 0.12) !important;\n  border: none !important;\n  backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.98) !important;\n  margin-top: 8px !important;\n  padding: 8px !important;\n  z-index: 1050 !important;\n  min-width: 180px !important;\n}\n\n.dropdown-item {\n  font-size: 14px;\n  padding: 8px 16px !important;\n  transition: all 0.2s ease;\n  border-radius: 6px !important;\n  color: #4a5568 !important;\n}\n\n.dropdown-item:hover {\n  background: rgba(102, 126, 234, 0.1) !important;\n  color: #667eea !important;\n}\n\n.dropdown-item.active {\n  background: rgba(102, 126, 234, 0.15) !important;\n  color: #667eea !important;\n  font-weight: 600;\n}\n\n.dropdown-divider {\n  margin: 8px 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n/* ========================================\n   响应式设计\n======================================== */\n@media (max-width: 1600px) {\n  .navbar {\n    padding: 12px 16px;\n  }\n\n  .nav-link-enhanced {\n    padding: 8px 10px !important;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 1400px) {\n  .navbar {\n    padding: 12px 20px;\n  }\n  \n  .nav-link-enhanced {\n    padding: 8px 10px !important;\n    font-size: 12px;\n  }\n  \n  .brand-section {\n    gap: 16px;\n    padding-right: 16px;\n  }\n  \n  .daat-logo {\n    width: 140px;\n  }\n  \n  .brand-tagline {\n    font-size: 9px;\n  }\n  \n  .tool-logo-link img {\n    width: 24px;\n  }\n  \n  .user-section {\n    margin-left: 16px;\n    padding-left: 16px;\n  }\n}\n\n@media (max-width: 1500px) {\n  .navbar-container {\n    margin-bottom: 16px;\n    padding-top: 10px;\n  }\n\n  .navbar {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 40px;\n    gap: 10px;\n    padding: 10px 12px;\n    border-radius: 12px;\n  }\n\n  .brand-section {\n    min-width: 0;\n    gap: 10px;\n    padding-right: 0;\n    border-right: 0;\n  }\n\n  .daat-logo {\n    width: 104px;\n    max-height: 36px;\n  }\n\n  .integrated-tools {\n    gap: 5px;\n  }\n\n  .tool-logo-link {\n    width: 28px;\n    height: 28px;\n    padding: 3px;\n    border-radius: 7px;\n  }\n\n  .tool-logo-link img {\n    width: 19px;\n    max-height: 17px;\n  }\n\n  .navbar-mobile-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border: 1px solid #dbe3ef;\n    border-radius: 8px;\n    background: #fff;\n    color: #334155;\n  }\n\n  .navbar-mobile-toggle:hover,\n  .navbar-mobile-toggle:focus-visible {\n    border-color: #93c5fd;\n    background: #eff6ff;\n    color: #1d4ed8;\n    outline: none;\n  }\n\n  .navbar .container-fluid {\n    display: none !important;\n    grid-column: 1 / -1;\n    padding-top: 10px;\n    border-top: 1px solid #eef2f7;\n  }\n\n  .navbar.mobile-menu-open .container-fluid {\n    display: block !important;\n  }\n\n  .navbar .nav,\n  .right-navbar-container,\n  .nav-items-center {\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .right-navbar-container,\n  .nav-items-center {\n    gap: 4px;\n  }\n\n  .nav-item-container,\n  .nav-link-enhanced,\n  #nav-dropdown {\n    width: 100%;\n  }\n\n  .nav-label {\n    display: inline;\n  }\n\n  .nav-link-enhanced,\n  #nav-dropdown {\n    justify-content: flex-start;\n    min-height: 42px;\n    padding: 9px 12px !important;\n    font-size: 13px !important;\n  }\n\n  .navbar-user-slot {\n    justify-content: stretch;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid #eef2f7;\n  }\n\n  .user-section,\n  .user-dropdown,\n  .user-dropdown .user-toggle {\n    width: 100%;\n  }\n\n  .user-section {\n    margin-left: 0;\n    padding-left: 0;\n    border-left: 0;\n  }\n\n  .user-menu {\n    width: 100%;\n    min-width: 0 !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1200px) {\n  .brand-tagline {\n    display: none;\n  }\n  \n  .tools-label {\n    display: none;\n  }\n  \n  .nav-label {\n    display: none;\n  }\n  \n  .nav-link-enhanced {\n    padding: 8px !important;\n    gap: 0;\n  }\n  \n  .nav-icon {\n    font-size: 18px;\n  }\n}\n\n/* ========================================\n   其他样式\n======================================== */\n.NavLink-with-divider {\n  border-right: none;\n  padding: 0;\n  position: relative;\n}\n\n.NavLink-with-divider::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 55%;\n  border-left: 2px solid rgb(200, 200, 200);\n}\n\n.left-navbar-container {\n  display: flex;\n  flex-direction: row;\n  margin-left: 1rem;\n}\n\n.custom-style {\n  background-color: #f8f9fa;\n  border-radius: 0.5rem;\n}\n\n.nav-item-container + .nav-item-container::before,\n.nav-link-enhanced::before {\n  display: none;\n}\n\n.nav-link-enhanced,\n.nav-link {\n  justify-content: center;\n  text-align: center;\n  gap: 8px;\n  border-radius: 10px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 11px !important;\n  transition: background-color 0.18s ease, color 0.18s ease;\n}\n\n.nav-link-enhanced:hover,\n.nav-link:hover {\n  background: #f1f5f9;\n  color: #1d4ed8;\n  transform: none;\n}\n\n.nav-link-enhanced.active,\n.nav-link.active {\n  background: #eff6ff !important;\n  color: #1d4ed8 !important;\n  box-shadow: none;\n}\n\n.nav-icon {\n  width: 15px;\n  height: 15px;\n  color: currentColor;\n  opacity: 0.9;\n}\n\n.nav-link-enhanced:hover .nav-icon {\n  transform: none;\n}\n\n.nav-indicator {\n  display: none;\n}\n\n.user-section {\n  margin-left: 14px;\n  padding-left: 14px;\n  border-left: 1px solid #e5e7eb;\n}\n\n.user-dropdown .dropdown-toggle,\n.user-dropdown .user-toggle {\n  gap: 10px;\n  padding: 6px 10px !important;\n  border-radius: 12px !important;\n  box-shadow: none !important;\n}\n\n.user-dropdown .dropdown-toggle:hover,\n.user-dropdown .user-toggle:hover {\n  background: #f8fafc !important;\n  border-color: #bfdbfe !important;\n  box-shadow: none;\n}\n\n.user-avatar,\n.user-avatar-large {\n  background: #2563eb;\n  box-shadow: none;\n}\n\n.user-email {\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.user-org {\n  color: #64748b;\n}\n\n.dropdown-toggle:hover,\n.nav-dropdown:hover {\n  background: #f1f5f9 !important;\n  color: #1d4ed8 !important;\n  transform: none;\n}\n\n.dropdown-menu,\n.user-menu {\n  border: 1px solid #e5e7eb !important;\n  border-radius: 12px !important;\n  background: #ffffff !important;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.12) !important;\n  backdrop-filter: none;\n}\n\n.menu-header {\n  background: #f8fafc;\n}\n\n.menu-item .item-icon {\n  width: 16px;\n  height: 16px;\n  font-size: 16px;\n}\n\n.navbar .nav-link-enhanced,\n.navbar #nav-dropdown {\n  white-space: nowrap;\n}\n\n@media (min-width: 769px) and (max-width: 1500px) {\n  .navbar.mobile-menu-open .nav-items-center {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .brand-section {\n    gap: 12px;\n    padding-right: 12px;\n  }\n\n  .daat-logo {\n    width: 128px;\n  }\n\n  .integrated-tools {\n    gap: 5px;\n  }\n\n  .tool-logo-link {\n    width: 30px;\n    height: 30px;\n  }\n\n  .right-navbar-container {\n    gap: 8px;\n  }\n\n  .nav-items-center {\n    gap: 2px;\n  }\n\n  .navbar .nav-link-enhanced,\n  .navbar #nav-dropdown {\n    gap: 5px;\n    padding: 7px !important;\n    font-size: 12px !important;\n  }\n\n  .user-section {\n    margin-left: 4px;\n    padding-left: 4px;\n  }\n\n  .user-dropdown .dropdown-toggle,\n  .user-dropdown .user-toggle {\n    gap: 8px;\n    padding: 6px 8px !important;\n  }\n}\n\n@media (max-width: 1500px) {\n  .navbar.mobile-menu-open .nav-label {\n    display: inline;\n  }\n\n  .navbar .nav-link-enhanced {\n    justify-content: flex-start;\n    gap: 8px;\n    min-height: 42px;\n    padding: 9px 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
